/**
 * Use Case: Update Voucher
 * Business logic for updating an existing voucher.
 */

import type {
  UpdateVoucherPayload,
  UpdateVoucherResult,
} from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Update an existing voucher
 */
export const UpdateVoucherUseCase = async (
  voucherId: string,
  payload: UpdateVoucherPayload
): Promise<UpdateVoucherResult> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.updateVoucher(voucherId, payload);
};

